<template>
  <div class="hero is-light is-small">
    <!-- Hero image -->
    <div id="main-hero" class="hero-body mb-80">
      <div class="container has-text-centered">
        <div class="columns is-vcentered mt-80 mb-80">
          <div class="column is-6 is-offset-3">
            <!-- Login form -->
            <div id="login-card" class="animated preFadeInLeft fadeInLeft">
              <div class="flex-card clean-login-card">
                <router-link to="/" class>
                  <img
                    class
                    src="~/../assets/images/logos/brand-logo.png"
                    alt
                  />
                </router-link>
                <template v-if="!otpStatus">
                  <form @submit.prevent="validateBeforeSubmitOtp">
                    <article class="message is-danger">
                      <div class="notification is-danger" v-if="message">
                        <strong>
                          <b>أرجو التأكد من بيانات تسجيل الدخول الخاصة بك</b>
                        </strong>
                      </div>
                    </article>
                    <div class="field has-addons">
                      <div class="control">
                        <input
                          disabled
                          class="input has-text-centered is-medium is-english"
                          type="text"
                          value="@sahara.net.ly"
                          :class="{
                            input: true,
                            'is-danger': errors.has('username') || message,
                          }"
                        />
                      </div>
                      <div class="control is-expanded">
                        <input
                          v-model="usernameOtp"
                          name="usernamenew"
                          class="input has-text-centered has-text-black is-medium is-english is-fullwidth"
                          type="text"
                          placeholder="رقم الهاتف"
                          autofocus
                          v-validate="'required'"
                          :class="{
                            input: true,
                            'is-danger': errors.has('usernamenew') || message,
                          }"
                        />
                      </div>
                    </div>
                    <span
                      v-show="errors.has('usernamenew')"
                      class="help is-danger is-centered mt-0 mb-10"
                      >{{ errors.first("usernamenew") }}</span
                    >

                    <div class="field">
                      <div class="control">
                        <input
                          v-model="loginOtp.password"
                          name="password"
                          class="input has-text-centered has-text-black is-medium is-centered is-english"
                          type="password"
                          placeholder="كلمة السر"
                          v-validate="'required'"
                          :class="{
                            input: true,
                            'is-danger': errors.has('password') || message,
                          }"
                        />
                        <span
                          v-show="errors.has('password')"
                          class="help is-danger is-centered"
                          >{{ errors.first("password") }}</span
                        >
                      </div>
                    </div>
                    <span
                      v-show="otpMessage != null"
                      class="help is-danger is-centered"
                      >{{ otpMessage }}</span
                    >

                    <vue-recaptcha
                      ref="recaptcha"
                      sitekey="6Lf4BRsqAAAAAK2Q1H7mUN_sm7s3zcVRVAL2OnL6"
                      @verify="recaptchaSolvedOTP = true"
                      @expired="recaptchaSolvedOTP = false"
                      @error="recaptchaSolvedOTP = false"
                      v-if="failcountOTP >= 3"
                    >
                    </vue-recaptcha>

                    <div class="mt-20 mb-20">
                      <button
                        class="button secondary-btn is-medium is-shadowless is-fullwidth raised has-text-weight-bold"
                        :disabled="failcountOTP >= 3 && !recaptchaSolvedOTP"
                        v-bind:class="{ 'is-loading': isLoadingOtp }"
                      >
                        تسجيل الدخول
                      </button>
                    </div>

                    <b-message title="تنبيه" :type="'is-danger'" v-if="failOTP">
                      <strong
                        >أرجو التأكد من إدخال اسم المستخدم بالشكل الصحيح ، واسم
                        المستخدم هو رقم هاتفك الذي قمت بالتسجيل به ، وإذا لم تقم
                        بتغيير كلمة المرور الإفتراضية المرسلة إليك أرجو التأكد
                        من كتابة الأحرف اللاتينية بشكليها الكبير و الصغير كما
                        أرسلت إليك.</strong
                      >
                    </b-message>
                  </form>
                </template>

                <template v-if="otpStatus">
                  <form @submit.prevent="validateBeforeSubmit">
                    <article class="message is-danger">
                      <div class="notification is-danger" v-if="message">
                        <strong>
                          <b>أرجو التأكد من بيانات تسجيل الدخول الخاصة بك</b>
                        </strong>
                      </div>
                    </article>
                    <div class="field has-addons">
                      <div class="control">
                        <input
                          disabled
                          class="input has-text-centered is-medium is-english"
                          type="text"
                          value="@sahara.net.ly"
                          :class="{
                            input: true,
                            'is-danger': errors.has('username') || message,
                          }"
                        />
                      </div>
                      <div class="control is-expanded">
                        <input
                          v-model="username"
                          name="usernamenew"
                          class="input has-text-centered has-text-black is-medium is-english is-fullwidth"
                          type="text"
                          placeholder="رقم الهاتف"
                          autofocus
                          v-validate="'required'"
                          :class="{
                            input: true,
                            'is-danger': errors.has('usernamenew') || message,
                          }"
                        />
                      </div>
                    </div>
                    <span
                      v-show="errors.has('usernamenew')"
                      class="help is-danger is-centered mt-0 mb-10"
                      >{{ errors.first("usernamenew") }}</span
                    >

                    <div class="field">
                      <div class="control">
                        <input
                          v-model="login.password"
                          name="password"
                          class="input has-text-centered has-text-black is-medium is-centered is-english"
                          type="password"
                          placeholder="كلمة السر"
                          v-validate="'required'"
                          :class="{
                            input: true,
                            'is-danger': errors.has('password') || message,
                          }"
                        />
                        <span
                          v-show="errors.has('password')"
                          class="help is-danger is-centered"
                          >{{ errors.first("password") }}</span
                        >
                      </div>
                    </div>
                    <span class="help is-centered">
                      تم إرسال رمز تسجيل الدخول الى رقم هاتفك المسجل في البوابة
                      الإلكترونية
                    </span>
                    <span class="help is-centered">
                      {{ otpMessageSuccess }}****
                    </span>
                    <div class="field">
                      <div class="control">
                        <input
                          v-model="login.otp"
                          name="otp"
                          class="input has-text-centered has-text-black is-success is-medium is-centered is-english"
                          type="text"
                          placeholder="رمز تسجيل الدخول"
                          v-validate="'required'"
                          :class="{
                            input: true,
                            'is-danger': errors.has('otp') || message,
                          }"
                        />
                        <span
                          v-show="errors.has('otp')"
                          class="help is-danger is-centered"
                          >{{ errors.first("otp") }}</span
                        >
                      </div>
                    </div>
                    <vue-recaptcha
                      ref="recaptcha"
                      sitekey="6Lf4BRsqAAAAAK2Q1H7mUN_sm7s3zcVRVAL2OnL6"
                      @verify="recaptchaSolved = true"
                      @expired="recaptchaSolved = false"
                      @error="recaptchaSolved = false"
                    >
                    </vue-recaptcha>

                    <div class="mt-20 mb-20">
                      <button
                        class="button secondary-btn is-medium is-shadowless is-fullwidth raised has-text-weight-bold"
                        :disabled="!recaptchaSolved"
                        v-bind:class="{ 'is-loading': isLoading }"
                      >
                        تسجيل الدخول
                      </button>
                    </div>

                    <b-message title="تنبيه" :type="'is-danger'" v-if="fail">
                      <strong
                        >أرجو التأكد من إدخال اسم المستخدم بالشكل الصحيح ، واسم
                        المستخدم هو رقم هاتفك الذي قمت بالتسجيل به ، وإذا لم تقم
                        بتغيير كلمة المرور الإفتراضية المرسلة إليك أرجو التأكد
                        من كتابة الأحرف اللاتينية بشكليها الكبير و الصغير كما
                        أرسلت إليك ، و أرجو التأكد من رمز تسجيل الدخول المرسل
                        إليك عبر رسائل الهاتف المحمول ان يكون مدخل بشكل صحيح
                      </strong>
                    </b-message>
                  </form>
                </template>
              </div>

              <div class="hero-foot has-text-centered mt-40">
                <router-link to="/signup">
                  <a
                    class="button is-outline primary-btn is-medium has-text-weight-bold"
                    >ليس لديك حساب سجل في الخدمة الان!</a
                  >
                </router-link>
              </div>
            </div>
            <!-- /Login form -->
            <!-- Recover form -->
            <!-- /Recover form -->
          </div>
        </div>
      </div>
    </div>
    <!-- /Hero image -->
  </div>
</template>

<script>
import arabic from "vee-validate/dist/locale/ar";
import { VueRecaptcha } from "vue-recaptcha";

export default {
  name: "login",
  components: { VueRecaptcha },
  props: {
    fifa: { default: false, type: Boolean },
  },

  data() {
    return {
      recaptchaSolved: false,
      recaptchaSolvedOTP: false,
      failcount: 0,
      failcountOTP: 0,
      username: "",
      failOTP: false,
      fail: false,
      login: {
        username: "",
        password: "",
        otp: "",
        // fail: false,
        // grant_type: "password",
        // client_secret: "uD0IK0jWKnQ5vnxkvSrA253G2zT2EnUe5iohoVYf",
        // client_id: 5,
      },
      usernameOtp: "",
      loginOtp: {
        username: "",
        password: "",
        // fail: false,
        // grant_type: "password",
        // client_secret: "uD0IK0jWKnQ5vnxkvSrA253G2zT2EnUe5iohoVYf",
        // client_id: 5,
      },
      local: "ar",
      message: "",
      messageempty: "",
      isLoading: false,
      isLoadingOtp: false,
      otpStatus: false,
      otpMessage: null,
      otpMessageSuccess: null,
    };
  },
  methods: {
    validateBeforeSubmitOtp() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.otp();
          return;
        }
      });
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.logItIn();
          return;
        }
      });
    },
    otp() {
      this.failOTP = false;
      this.isLoadingOtp = !this.isLoadingOtp;
      if (/\s/.test(this.usernameOtp)) {
        this.usernameOtp = this.usernameOtp.replace(/ /g, "");
      }

      if (this.usernameOtp.includes("@sahara.net.ly")) {
        this.loginOtp.username = this.usernameOtp;
      } else {
        this.loginOtp.username = this.usernameOtp + "@sahara.net.ly";
      }
      axios.post("otp/", this.loginOtp).then((response) => {
        if (response.status == 200) {
          if (response.data.status.trim() == "success".trim()) {
            this.otpMessageSuccess = response.data.mobile_hint.split("*")[4];
            this.otpMessage = null;
            this.otpStatus = true;
            this.username = this.loginOtp.username.split('@')[0];
            this.login.password = this.loginOtp.password;
          } else {
            this.otpStatus = false;
            this.otpMessage = response.data.message;
            this.isLoadingOtp = !this.isLoadingOtp;

            //RECAPTCHA
            this.failOTP = true;
            this.failcountOTP++;
            if (this.failcountOTP > 3) {
              this.$refs.recaptcha.reset();
              this.recaptchaSolvedOTP = false;
            }
          }
        }
      });
    },
    logItIn() {
      this.isLoading = !this.isLoading;
      this.fail = false;

      if (/\s/.test(this.username)) {
        this.username = this.username.replace(/ /g, "");
      }

      if (this.username.includes("@sahara.net.ly")) {
        this.login.username = this.username;
      } else {
        this.login.username = this.username + "@sahara.net.ly";
      }
      axios
        .post("login/", this.login)
        .then((response) => {
          if (response.data.token) {
            let newToken = `Bearer ${response.data.token}`;
            window.token = newToken;

            var name = response.data.Name;
            var id = response.data.scope;

            window.scope = id;

            var user = [name, id];
            localStorage.setItem("token", response.data.token);
            localStorage.setItem("user", JSON.stringify(user));
            localStorage.setItem("email", this.login.username);

            window.axios.defaults.headers.common["Authorization"] = newToken;
            window.axios.defaults.headers.common["scope"] = window.scope;
            window.axios.defaults.params = { HashedId: user.HashedId };
            Event.$emit("login", user);
            // alert(this.fifa);

            if (this.fifa) {
              this.$router.push("/fifa");
            } else {
              this.$router.push("/portal");
            }
          } else {
            this.fail = true;
            this.failcount++;

            if (this.failcount > 3) {
              this.$refs.recaptcha.reset();
              this.recaptchaSolved = false;
            }
            this.isLoading = !this.isLoading;
            this.$toasted.show("أرجو التأكد من بيانات تسجيل الدخول الخاصة بك", {
              theme: "outline",
              position: "top-center",
              duration: 3000,
              type: "error",
              theme: "bubble",
              className: "toasti",
              iconPack: "fontawesome",
              closeOnSwipe: true,
            });
          }
        })
        .catch((error) => {
          this.isLoading = !this.isLoading;
          console.log(error);
          this.$toasted.show("هناك خطأ", {
            theme: "outline",
            position: "top-center",
            duration: 3000,
            type: "error",
            theme: "bubble",
            className: "toasti",
            iconPack: "fontawesome",
            closeOnSwipe: true,
            icon: {
              name: "fa-times",
              before: true, // this will append the icon to the end of content
            },
          });
        });
    },
    logIn() {
      this.isLoading = !this.isLoading;
      if (this.login.username == "" && this.login.password == "") {
        this.messageempty = true;
      } else if (
        this.login.username == "customer" &&
        this.login.password == "customer"
      ) {
        let newToken = "tokensample";
        window.token = newToken;
        let user = "user";
        localStorage.setItem("token", newToken);
        localStorage.setItem("user", JSON.stringify(user));
        window.axios.defaults.params = { api_token: newToken };
        Event.$emit("login");
        // alert(this.fifa);

        if (this.fifa) {
          this.$router.push("/fifa");
        } else {
          this.$router.push("/portal");
        }
      } else {
        this.message = true;
      }
    },
  },
  created() {
    if (localStorage.getItem("token") != null) {
      Event.$emit("login");

      this.$router.push("/portal");
    }
    this.$validator.localize("ar", {
      messages: arabic.messages,
      attributes: {
        usernamenew: "اسم المستخدم او رقم الهاتف",
        password: "كلمة السر",
      },
    });
  },
};
</script>
